import { VideoClip, VideoProject } from '@models/Sessions/Idea/VideoProject';
import keyBy from 'lodash/keyBy';

export const mapVideoClips = (
  videoProject: VideoProject,
): Record<VideoClip['_id'], VideoClip> => {
  return keyBy(
    videoProject.scenes.flatMap(({ shots }) => {
      return shots.flatMap(({ clips }) => {
        return clips;
      });
    }),
    ({ _id }) => {
      return _id;
    },
  );
};
